// @mui
import { alpha } from '@mui/material/styles';
//
import palette from './palette';

// ----------------------------------------------------------------------

interface CustomShadowOptions {
  z1: string;
  z4: string;
  z8: string;
  z12: string;
  z16: string;
  z20: string;
  z24: string;
  //
  primary: string;
  secondary: string;
  info: string;
  success: string;
  warning: string;
  error: string;
  //
  card: string;
  dialog: string;
  dropdown: string;
}

declare module '@mui/material/styles' {
  interface Theme {
    customShadows: CustomShadowOptions;
  }
  interface ThemeOptions {
    customShadows?: CustomShadowOptions;
  }
}

// ----------------------------------------------------------------------

const themeColor = palette('light');

const LIGHT_MODE = themeColor.grey[500];

const DARK_MODE = themeColor.common.black;

function createShadow(color: string) {
  const transparent = alpha(color, 0.2);
  return {
    z1: `0 1px 2px 0 ${transparent}`,
    z4: `0 6px 12px 0 ${transparent}`,
    z8: `0 10px 20px 0 ${transparent}`,
    z12: `0 14px 28px -4px ${transparent}`,
    z16: `0 18px 36px -6px ${transparent}`,
    z20: `0 22px 44px -6px ${transparent}`,
    z24: `0 26px 52px -8px ${transparent}`,
    //
    primary: `0 10px 20px 0 ${alpha(themeColor.primary.main, 0.32)}`,
    info: `0 10px 20px 0 ${alpha(themeColor.info.main, 0.32)}`,
    secondary: `0 10px 20px 0 ${alpha(themeColor.secondary.main, 0.32)}`,
    success: `0 10px 20px 0 ${alpha(themeColor.success.main, 0.28)}`,
    warning: `0 10px 20px 0 ${alpha(themeColor.warning.main, 0.28)}`,
    error: `0 10px 20px 0 ${alpha(themeColor.error.main, 0.28)}`,
    //
    card: `0 0 2px 0 ${alpha(color, 0.28)}, 0 16px 32px -6px ${alpha(color, 0.24)}`,
    dialog: `-40px 40px 90px -12px ${alpha(color, 0.45)}`,
    dropdown: `0 0 2px 0 ${alpha(color, 0.28)}, -20px 22px 44px -6px ${alpha(color, 0.3)}`,
  };
}

export default function customShadows(themeMode: 'light' | 'dark') {
  return themeMode === 'light' ? createShadow(LIGHT_MODE) : createShadow(DARK_MODE);
}
